import './css/App.scss'

import { Routes, Route } from "react-router-dom"
import Home from './pages/Home'
import OurStory from './pages/OurStory'
import RSVP from './pages/RSVP'
import Details from './pages/Details'
import Entourage from './pages/Entourage'
import Stay from './pages/Stay'
import FAQ from './pages/FAQ'
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="our-story" element={<OurStory />} />
          <Route path="rsvp" element={<RSVP />} />
          <Route path="details" element={<Details />} />
          <Route path="entourage" element={<Entourage />} />
          <Route path="stay" element={<Stay />} />
          <Route path="faq" element={<FAQ />} />
        </Routes>
      </div>
    </ThemeProvider>
  );
}

export default App;
